export default __webpack_public_path__ + "static/accelerate-ai-dark-652df7d98943a5903f3de628962b09384b59362219fceae3576f69d5f164d3d8.png";